import React from 'react'

import MicrocmsImage from '@atoms/MicrocmsImage'
import { ProfileContent } from '@models/Article'
import { useTranslation } from '@models/Translation'

import * as style from './style.module.sass'

type ProfileProps = ProfileContent & {
  isArtisan?: boolean
}

const Profile: React.FC<ProfileProps> = ({
  contents,
  name,
  image,
  isArtisan,
}) => {
  const { locale } = useTranslation()

  return (
    <div className={style.profile} data-artisan={isArtisan}>
      <div className={style.title}>
        PROFILE{locale === 'ja' && '｜プロフィール'}
      </div>
      <div className={style.contents}>
        {image !== null && image !== undefined && (
          <MicrocmsImage image={image} alt={name} type="thumbnail" />
        )}
        <div>
          <div className={style.name}>{name}</div>
          <div
            className={style.description}
            dangerouslySetInnerHTML={{ __html: contents }}
          />
        </div>
      </div>
    </div>
  )
}

export default Profile
